// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ApiKeyExtendIn = zod.object({
  "expires_on": zod.iso.date()
});

export type ApiKeyExtendIn = zod.input<typeof ApiKeyExtendIn>;
export type ApiKeyExtendInOutput = zod.output<typeof ApiKeyExtendIn>;
